import React from 'react'
import { Link } from 'react-router-dom'
import { SIDEBAR_LEFT_CLASS } from '../../tools'

const ServiceSubPageHeader = ({ title, onBack, backLabel, actions, search, user }) => {
	let avatarEl = (
		<span className="inline-flex h-8 w-8 rounded-full bg-gray-200 items-center justify-center shrink-0">
			<svg className="w-4 h-4 text-gray-500" fill="currentColor" viewBox="0 0 24 24">
				<path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" />
			</svg>
		</span>
	)
	if (user && user.avatar)
		avatarEl = <img className="h-8 w-8 rounded-full shrink-0" src={user.avatar} alt="avatar" />

	return (
		<div className={`fixed top-0 left-0 ${SIDEBAR_LEFT_CLASS} right-0 z-30 flex items-center justify-between px-6 h-14 bg-white shadow-sm border-b border-gray-100`}>
			<button
				onClick={onBack}
				className="flex items-center gap-1 text-sm text-gray-500 hover:text-gray-800 transition-colors"
			>
				<svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
					<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
				</svg>
				{backLabel || 'Services'}
			</button>

			{search ? (
				<div className="flex items-center bg-gray-100 rounded-xl px-4 py-2 border border-gray-200 w-80">
					<svg className="w-4 h-4 text-gray-400 mr-3 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
						<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0" />
					</svg>
					<input
						type="text"
						placeholder={typeof search === 'object' && search.placeholder ? search.placeholder : 'Rechercher...'}
						className="browser-default bg-transparent text-sm w-full text-gray-700 placeholder-gray-400"
						style={{ border: 'none', outline: 'none', boxShadow: 'none', height: 'auto', margin: 0, padding: 0 }}
					/>
				</div>
			) : (
				<h1 className="text-base font-semibold text-gray-900">{title}</h1>
			)}

			<div className="flex items-center gap-3">
				{actions}
				<Link to="/parametres">
					{avatarEl}
				</Link>
			</div>
		</div>
	)
}

export default ServiceSubPageHeader
